import React from 'react'
import './style.css'

const AppPublishStatusView = ({ iconSrc, title, description }) => (
  <div className="app-publish-status-view">
    <div className="app-publish-status-view-title">
      <img src={iconSrc} alt="status" />
      <span>{title}</span>
    </div>
    <p className="app-publish-status-view-description">
      {description}
    </p>
  </div>
)

export default AppPublishStatusView
